import Vue from 'vue'
import * as Mixins from './'

const mixins = Object.values(Mixins).filter(m => m)

mixins.forEach(mixin => Vue.mixin(mixin))

export default mixins



// WEBPACK FOOTER //
// ./src/shared/mixins/index.js